import type { FaireProductEntity } from "../../entity_types/product";

export const p_fmts3cjyzh: FaireProductEntity = {
  token: "p_fmts3cjyzh",
  type: "product",
  name: "fox sticker",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/c10f49faea39900441a47d589dad9690153bb3d0e203bcb604cacd71a29d3e1f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b472e944f9a7893f64384b6b3f7c76146b25af7852c6040082bc84c95ad13db.jpeg",
  ],
  priceDollars: 2,
  description:
    'Add this sticker to your water bottle, laptop, journal, envelopes, and more.\n\n• vinyl sticker\n• 3" x 3"\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:07.094Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
